/**
 * The element a dialog opened from a menu item should hand focus back to (WCAG 2.4.3).
 *
 * A Radix DropdownMenu item (or any `role="menu"` item) holds focus when it is chosen, and the menu unmounts when it closes,
 * so remembering `document.activeElement` as the opener remembers an element that is gone. The menu's content is labelled by
 * its trigger (`aria-labelledby` = the trigger's id, which Radix sets), so for a focused element inside a menu this returns
 * that trigger; any other element is returned as is.
 */
export function resolveOpener(el: Element | null): HTMLElement | null {
  if (!el) return null;
  const menu = el.closest('[role="menu"]');
  const triggerId = menu?.getAttribute('aria-labelledby');
  const trigger = triggerId ? document.getElementById(triggerId) : null;
  return (trigger ?? el) as HTMLElement;
}
